import { render, staticRenderFns } from "./TabelaCertidoes.vue?vue&type=template&id=b05ea3b6&scoped=true"
import script from "./TabelaCertidoes.vue?vue&type=script&lang=ts"
export * from "./TabelaCertidoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05ea3b6",
  null
  
)

export default component.exports